module.exports = __webpack_public_path__ + "img/AI123Img.ce56def4.png";